import React from 'react';
import { Skeleton } from '@mui/material';

export const boneSx = (isDark) => ({
  bgcolor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.06)',
});

/** Skeleton for a single metric value — keeps labels/icons visible in parent. */
export const MetricValueSkeleton = ({ isDark, valueHeight = 28, subHeight = 14 }) => (
  <>
    <Skeleton variant="text" width="72%" height={valueHeight} animation="wave" sx={boneSx(isDark)} />
    <Skeleton variant="text" width="58%" height={subHeight} animation="wave" sx={{ ...boneSx(isDark), mt: 0.35 }} />
    <Skeleton variant="rounded" height={6} animation="wave" sx={{ ...boneSx(isDark), mt: 1.5, borderRadius: 999 }} />
  </>
);

export const StatValueSkeleton = ({ isDark, height = 32, width = '40%' }) => (
  <Skeleton variant="text" width={width} height={height} animation="wave" sx={boneSx(isDark)} />
);

export const ChartAreaSkeleton = ({ isDark, height = 280, sx = {} }) => (
  <Skeleton
    variant="rounded"
    height={height}
    animation="wave"
    sx={{ borderRadius: 2.4, ...boneSx(isDark), ...sx }}
  />
);

export const AsyncValue = ({
  loading,
  isDark,
  children,
  skeletonHeight = 32,
  skeletonWidth = '45%',
}) => (
  loading
    ? <StatValueSkeleton isDark={isDark} height={skeletonHeight} width={skeletonWidth} />
    : children
);
